
import * as angular from "angular";
import { VeriDate } from "@services/veriDate.service";

export function minutesToDuration(veriDate: VeriDate) {

    return (inputMinutes: number, exceptionValue?: number, exceptionString?: string, shortHand = true) => {

        return veriDate.minutesToDurationString(inputMinutes, exceptionValue, exceptionString, shortHand);
    }
}
